import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  customVariables: ["~/assets/variables.scss"],
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      light: {
        primary: "#E2AF47",
        secondary: "#000000",
        accent: "#8c9eff",
        error: "#b71c1c",
        // cta: "#47CC96",
        cta: "#4684E3",
        "body-bg": "#F5F5F5",
        "body-text": "#606060",
        checkbox: "#8F8F8F",
        "grey-accent": "#EDEDED",
        "brand-orange": "#FFA937",
        "brand-green": "#B7D44A",
        grey: colors.grey
      }
    },
    options: {
      customProperties: true
    }
  }
});
